<template>
  <div class="br-list-section">
    <h3 class="br-list-title br-list-title--lg">{{ title }}</h3>
    <div v-if="items.length" class="br-list-items">
      <div
        v-for="item in items"
        :key="itemKey(item)"
        :class="isAdmin ? 'br-admin__item' : null"
      >
        <slot name="item" :item="item" :is-current-display="isCurrentDisplay" />
      </div>
    </div>
    <slot v-else-if="showEmpty" name="empty" />
  </div>
</template>

<script>
export default {
  name: 'BrListSection',
  props: {
    title: { type: String, required: true },
    items: { type: Array, default: () => [] },
    variant: {
      type: String,
      default: 'supplier',
      validator: (v) => ['supplier', 'admin'].includes(v),
    },
    isCurrentDisplay: { type: Boolean, default: false },
    showEmpty: { type: Boolean, default: false },
    keyPrefix: { type: String, default: 'br' },
  },
  computed: {
    isAdmin() {
      return this.variant === 'admin';
    },
  },
  methods: {
    itemKey(item) {
      const id = item?.approvalId ?? item?.ApprovalId
        ?? item?.businessRegistrationId ?? item?.BusinessRegistrationId
        ?? '';
      return `${this.keyPrefix}-${item?.listKind || ''}-${id}`;
    },
  },
};
</script>
